import React, { useEffect, useRef, useState } from "react";

/**
 * CORE Hook: يراقب الضغطات الخارجية لإغلاق القوائم تلقائياً
 */
function useOutsideAlerter(ref, setX) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        setX(false);
      }
    }
    // ربط الحدث بنظام التشغيل
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // تنظيف الذاكرة عند إغلاق المكون لضمان سرعة النظام
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref, setX]);
}

const Dropdown = (props) => {
  const { button, children, classNames, animation } = props;
  const wrapperRef = useRef(null);
  const [openWrapper, setOpenWrapper] = useState(false);

  // تفعيل المراقب الذكي
  useOutsideAlerter(wrapperRef, setOpenWrapper);

  return (
    <div ref={wrapperRef} className="relative flex">
      {/* زر التشغيل */}
      <div
        className="flex cursor-pointer"
        onClick={() => setOpenWrapper(!openWrapper)}
      >
        {button}
      </div>

      {/* محتوى القائمة المنسدلة */}
      <div
        className={`${classNames} absolute z-50 transition-all duration-300 ease-in-out ${
          animation ? animation : "origin-top-right"
        } ${
          openWrapper
            ? "visible scale-100 opacity-100"
            : "pointer-events-none invisible scale-95 opacity-0"
        }`}
      >
        {children}
      </div>
    </div>
  );
};

export default Dropdown;
